<!-- Full Page View -->
@if (isFullPage) {
  <div class="tw-block tw-border-spacing-0 tw-w-full tw-h-screen tw-font-body tw-relative">
    @if (isLoading) {
      <div class="tw-absolute tw-top-1/2 tw-left-1/2 tw-translate-x-[-50%] tw-translate-y-[-50%] tw-z-20">
        <loading></loading>
      </div>
    }
    @if (!isLoading && shouldRenderComponent) {
      <div class="tw-h-full tw-flex tw-flex-col">
        <!-- Fixed Header Icons -->
        <div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="navigateBack()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
        </div>
        <div class="tw-fixed tw-right-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="navigateToCart()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'shopping_cart'"></cs-icon>
          <span class="tw-absolute tw-top-[2px] tw-right-[18%] tw-bg-black tw-font-body tw-font-bold tw-h-[14px] tw-text-200 tw-text-red-400">
            {{cartToolbarIcon?.cartValue}}
          </span>
        </div>
        <!-- Scrollable Content Area -->
        <div class="tw-flex-1 tw-overflow-y-auto tw-bg-gray-50"
          [style.padding-bottom]="(totalSellingPrice && cartToolbarIcon.cartValue) ? '8rem' : '1rem'"
          [style.padding-top]="'6rem'">
          <div class="tw-p-4 tw-relative tw-flex tw-flex-col tw-items-start tw-justify-end" id="sectionTitle" style="padding-top: unset;">
            <div class="tw-text-[20px] tw-font-bold tw-text-gray-800">
              <span i18n="@@recentlyViewedProducts">Recently Viewed Products</span>
            </div>
          </div>
          <product-card-grid
            [isShopRevampExperimentOn]="isShopRevampExperimentOn"
            [showRemoveProductIcon]="showRemoveProductIcon"
            [products]="products"
            [productsInCart]="cartProductQuantities"
            [cartItems]="cartItems"
            [section]="gridSection"
            (productClicked)="onProductClick($event)"
            (removeProductClick)="onRemoveProductClick($event)"
            (cartUpdated)="onSucessfulCartUpdate($event)">
          </product-card-grid>
        </div>
        <!-- AOV Banner Section -->
        @if (isAovExpEnabled && isAOVActive && !isLoading && !isNewCartUIEnabled) {
          <aov-sale class="tw-w-full"
            [numberOfProductsInCart]="cartToolbarIcon.cartValue"
            [maxPrice]="aovConfiguration?.totalValue || 0"
            [showConfettiAnimation]="shouldShowConfettiAnimation"
            [barStyle]="aovProgressBarStyle"
            [cart]="cartItems"
            [prodImage]="aovProductImage"
            [amountRemaining]="aovAmountRemaining"
            [fromListingPage]="true"
            [bottomBar]="totalSellingPrice && !isLoading"
            (onCheckout)="navigateToCheckout()">
          </aov-sale>
        }
        @if (isAovExpEnabled && isAOVActive && !isLoading && isNewCartUIEnabled) {
          <div class="tw-absolute tw-w-full" [ngClass]='{ "tw-h-32 tw-bottom-8": totalSellingPrice && !isLoading, "tw-h-16 tw-bottom-2": !(totalSellingPrice && !isLoading) }'>
            <app-aov-banner
              [amountRemaining]="aovAmountRemaining"
              [freeProductBannerImage]="aovProductImage"
              [percentageDone]="cartToolbarIcon.cartValue ? aovProgressPercentage : 0"
              [isEnglishLanguage]="currentUser?.get('languagePreference') === appConfig.Shared.Languages.EN"
              [displayWhenAmountRemainingIsZero]="true">
            </app-aov-banner>
          </div>
        }
        <!-- Bottom Cart Section -->
        @if (totalSellingPrice && cartToolbarIcon.cartValue) {
          <div class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-shadow-[0_-1px_7px_rgba(0,0,0,0.13)] tw-w-full tw-z-10 tw-bg-white">
            @if (+discount >= 5 && !isAovExpEnabled) {
              <div class="tw-flex tw-item-center tw-justify-center tw-py-2 tw-bg-yellow-100">
                <p class="tw-font-body tw-text-200 tw-text-black tw-flex tw-items-center tw-gap-1">
                  <cs-icon class="tw-h-5 tw-w-5 tw-text-green-400" [iconName]="'sale'"></cs-icon>
                  <span i18n="@@discountAppliedForProducts">
            {{ discount }}% discount applied</span>
                </p>
              </div>
            }
            <div class="tw-flex tw-items-center tw-p-5 tw-pl-3">
              <div class="tw-flex tw-items-center tw-mr-1">
                <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-500" [iconName]="'shopping_cart'"></cs-icon>
                @if (+cartToolbarIcon.cartValue === 1) {
                  <p class="tw-font-body tw-text-gray-500 tw-text-200" i18n="@@singleProduct">
            1 product -
          </p>
                }
                @if (+cartToolbarIcon.cartValue !== 1) {
                  <p class="tw-font-body tw-text-gray-500 tw-text-200"
                    i18n="@@multipleProducts">
              {{ cartToolbarIcon.cartValue }} products -
          </p>
                }
              </div>
              <div class="tw-flex-none tw-mr-4">
                <span
                  class="tw-font-body tw-font-bold tw-text-500 tw-text-teal-600 tw-bg-white">
                  ₹{{totalSellingPrice%1 != 0 ? totalSellingPrice.toFixed(2) : totalSellingPrice}}
                </span>
              </div>
              <div class="tw-flex-auto">
                <button
                  class="tw-h-[49px] tw-w-full tw-gap-2 tw-items-center tw-leading-none shine-button tw-bg-teal-600 tw-text-white"
                  (click)="navigateToCheckout()">
                  <cs-button-text class="tw-font-body tw-font-bold tw-text-300" i18n="@@buyNow">Buy Now</cs-button-text>
                  <cs-icon class="tw-h-7 tw-w-7 tw-text-white" [iconName]="'chevron_right'"></cs-icon>
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
}


<!-- Embedded View in user home and shop page -->
@if (!isFullPage && shouldRenderComponent) {
  <div>
    @if (recentlyViewedProducts?.length && !isLoading) {
      <div class="tw-pt-4 tw-pb-4 tw-pl-4 tw-font-body" [ngClass]="{'tw-bg-gradient-cream-to-white': !isShopRevampExperimentOn, 'tw-my-2 tw-bg-gradient-teal-to-white': isShopRevampExperimentOn }">
        <div class="tw-flex tw-items-center tw-justify-between tw-pr-5">
          <div class="tw-text-gray-800 tw-font-bold" [class]="isShopRevampExperimentOn ? 'tw-text-500 tw-font-lexend' : 'tw-font-body tw-text-300'">
            <span i18n="@@recentlyViewedProducts">Recently Viewed Products</span>
          </div>
          <div class="tw-flex tw-font-body tw-text-200 tw-text-gray-700 tw-normal-case" (click)="navigateToRecentlyViewedPage()">
            @if (isShopRevampExperimentOn) {
              <cs-icon class="tw-w-6 tw-h-6 tw-text-teal-500" [iconName]="'chevron_right'" />
            } @else {
              <span i18n="@@recentlyViewedViewAll">View all</span>
              <em class="cs-icon-arrow"></em>
            }
          </div>
        </div>
        @if (recentlyViewedProducts?.length) {
          <div class="tw-h-[128px] tw-flex tw-gap-2 tw-overflow-x-auto tw-overflow-y-hidden tw-w-full" [class]="isShopRevampExperimentOn ? 'tw-mt-3' : 'tw-mt-2'">
            @for (recentView of recentlyViewedProducts; track recentView.objectId) {
              <div class="tw-py-3 tw-px-2 tw-w-[70vw] tw-h-[120px] tw-bg-white tw-shadow-z4 tw-gap-2 tw-flex-shrink-0 tw-flex-grow-0 tw-min-w-[70vw] tw-max-w-[70vw] tw-rounded-2 tw-flex tw-overflow-hidden last:tw-mr-4"
                (click)="onProductClick(recentView.product)"
                role="button"
                tabindex="0"
                [attr.aria-label]="'View product: ' + recentView?.product?.title">
                <img
                  [src]="getProductImage(recentView.product)"
                  class="tw-w-[78px] tw-shrink-0 tw-rounded-1 tw-object-cover"
                  [alt]="recentView?.product?.title"
                  #productImage
                  />
                <div class="tw-flex tw-flex-col tw-flex-1 tw-justify-between tw-min-w-0 tw-overflow-hidden">
                  <div class="tw-flex-1 tw-min-h-0">
                    @if (getProductTag(recentView).show) {
                      <h2 class="cart-page-tag-bg-gradient tw-h-4 tw-w-fit tw-text-50 tw-pl-[5px] tw-font-medium tw-rounded-1 tw-mb-1"
                        >
                        @switch (getProductTag(recentView).type) {
                          @case ('previouslyBought') {
                            <span i18n="@@previouslyBought">Previously Bought</span>
                          }
                          @case ('bestSeller') {
                            <span i18n="@@bestSeller">Best Seller</span>
                          }
                          @default {
                            <span>{{getProductTag(recentView).text}}</span>
                          }
                        }
                      </h2>
                    }
                    <h1 class="tw-font-lexend tw-text-gray-800 tw-text-200 tw-pr-1">{{recentView?.product?.title}}</h1>
                  </div>
                  <div class="tw-flex tw-justify-between tw-items-end tw-gap-2 tw-mt-2 tw-min-w-0 tw-font-lexend">
                    <div class="tw-flex-1 tw-min-w-0 tw-font-lexend">
                      <span class="tw-text-400 tw-font-bold tw-block tw-leading-[16px] tw-text-orange-500">₹{{ recentView?.product?.price }}</span>
                      <del class="tw-text-gray-400 tw-block tw-text-200">₹{{ recentView?.product?.mrp }}</del>
                    </div>
                    <!-- Show quantity controls if product is in cart -->
                    @if (getProductQuantityInCart(recentView) > 0) {
                      <div class="tw-flex tw-items-center tw-gap-1 tw-bg-teal-600 tw-rounded-3 tw-px-2 tw-py-1 tw-flex-shrink-0 tw-max-w-[80px] tw-font-lexend"
                        >
                        <div class="tw-text-white tw-font-bold tw-text-300 tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-leading-none tw-flex-shrink-0 tw-cursor-pointer tw-font-lexend"
                          (click)="onAddToCartClick(recentView.product, 'REMOVE', $event, undefined, getProductTag(recentView).text)"
                          [attr.aria-label]="'Remove ' + recentView?.product?.title + ' from cart'"
                          role="button"
                        tabindex="0">-</div>
                        <span class="tw-text-white tw-font-bold tw-text-300 tw-min-w-[16px] tw-text-center tw-flex-shrink-0">{{ getProductQuantityInCart(recentView) }}</span>
                        <div class="tw-text-white tw-font-bold tw-text-300 tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-leading-none tw-flex-shrink-0 tw-cursor-pointer tw-font-lexend"
                          (click)="onAddToCartClick(recentView.product, 'ADD', $event, productImage, getProductTag(recentView).text)"
                          [attr.aria-label]="'Add more ' + recentView?.product?.title + ' to cart'"
                          role="button"
                        tabindex="0">+</div>
                      </div>
                    }
                    <!-- Show Add button if product is not in cart -->
                    @if (getProductQuantityInCart(recentView) === 0) {
                      <div class="tw-bg-teal-600 tw-w-20 tw-h-8 tw-text-white tw-text-200 tw-font-bold tw-flex tw-justify-center tw-items-center tw-rounded-2 tw-flex-shrink-0 tw-max-w-[80px] tw-font-lexend"
                        (click)="onAddToCartClick(recentView.product, 'ADD', $event, productImage, getProductTag(recentView).text)"
                        role="button"
                        tabindex="0"
                        [attr.aria-label]="'Add ' + recentView?.product?.title + ' to cart'"
                      i18n="@@add">Add</div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
